// extracted by mini-css-extract-plugin
export default {"outerDiv":"login-page_outerDiv__uzlM7","yuvaImg":"login-page_yuvaImg__7sIVU","dualBannerWrap":"login-page_dualBannerWrap__wurMt"};